import { MigrationDefinition } from './migration.types';

/**
 * Migration: V4 → V5
 *
 * Upgrade:
 * - Bodenvegetationen[] → bodenvegetation.aufnahme.vegetationen[]
 * - Neue Struktur mit schichtAnteile
 *
 * Downgrade:
 * - bodenvegetation.aufnahme.vegetationen[] → Bodenvegetationen[]
 * - bodenvegetation-Objekt BEHALTEN (alte App ignoriert es)
 */
export const migrationV4ToV5: MigrationDefinition = {
  fromVersion: 4,
  toVersion: 5,

  upgrade(doc: any): any {
    if (doc.Bodenvegetationen) {
      // Bestehende schichtAnteile erhalten (falls vorhanden von früherem Roundtrip)
      const existingSchichtAnteile = doc.bodenvegetation?.aufnahme?.schichtAnteile || {};
      doc.bodenvegetation = {
        aufnahme: {
          schichtAnteile: existingSchichtAnteile,
          vegetationen: doc.Bodenvegetationen
        }
      };
      delete doc.Bodenvegetationen;
    }

    doc.version = 5;
    return doc;
  },

  downgrade(doc: any): any {
    // bodenvegetation.aufnahme.vegetationen → Bodenvegetationen
    if (doc.bodenvegetation?.aufnahme?.vegetationen) {
      doc.Bodenvegetationen = doc.bodenvegetation.aufnahme.vegetationen;
      // bodenvegetation-Objekt BEHALTEN - alte App ignoriert es,
      // aber Daten (schichtAnteile) bleiben für späteres Upgrade erhalten
    }

    doc.version = 4;
    return doc;
  },

  dataLossWarnings: [
    'bodenvegetation.aufnahme.schichtAnteile wird bei V4-Apps nicht angezeigt'
  ]
};
